import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setZoom } from "./reducers/ZoomSlice";

const ZoomClassSync = () => {
  const dispatch = useDispatch();
  const zoomLevel = useSelector((state) => state.zoom.zoomLevel);

  useEffect(() => {
    const checkZoom = () => {
      const isMobile = window.matchMedia("(pointer: coarse)").matches;
      const isMac = /Mac|Macintosh/.test(navigator.userAgent);

      if (isMobile) {
        dispatch(setZoom(null));
        return;
      }

      let zoom = Math.round(window.devicePixelRatio * 100);

      // Normalize default Retina scaling on Mac
      if (isMac && window.devicePixelRatio === 2) {
        zoom = 100; // Treat Retina 2x as 100%
      }

      // Allow all zoom levels between 200–400 inclusive
      const level = zoom >= 200 && zoom <= 400 ? zoom : null;
      dispatch(setZoom(level));
    };

    checkZoom();
    window.addEventListener("resize", checkZoom);
    return () => window.removeEventListener("resize", checkZoom);
  }, [dispatch]);

  useEffect(() => {
    const body = document.body;

    body.classList.remove(
      "desktop-only-zoom-200",
      "desktop-only-zoom-300",
      "desktop-only-zoom-400",
      "zoomin"
    );

    if (zoomLevel !== null && zoomLevel >= 200 && zoomLevel <= 400) {
      body.classList.add("zoomin");

      if ([200, 300, 400].includes(zoomLevel)) {
        body.classList.add(`desktop-only-zoom-${zoomLevel}`);
      }
    }

    return () => {
      body.classList.remove("zoomin");
      if ([200, 300, 400].includes(zoomLevel)) {
        body.classList.remove(`desktop-only-zoom-${zoomLevel}`);
      }
    };
  }, [zoomLevel]);

  return null;
};

export default ZoomClassSync;
